import { Menu, MenuDropdownProps, MenuItemProps } from '@mantine/core';
import type { ComponentProps, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainMenuItem = asPlainComponent<ComponentProps<typeof Menu.Item>>(Menu.Item);

export const TableContainer = styled.div`
	width: 100%;
`;

export const StyledMenuItem = styled(PlainMenuItem)<
	MenuItemProps & { onClick?: MouseEventHandler<HTMLDivElement> }
>`
	min-width: 15rem;
	display: flex;
	align-items: center;
	align-self: stretch;

	border-radius: 0.25rem;
	border: 1px solid ${(props) => props.theme.v2.color.white};
	background: ${(props) => props.theme.v2.color.white};

	&& {
		padding: 0.5rem;
		line-height: 1.5;
	}
`;

export const StyledMenuDropdown = styled(Menu.Dropdown)<MenuDropdownProps>`
	display: flex;
	min-width: 15rem;
	padding: 0.25rem;
	flex-direction: column;
	align-items: flex-start;

	border-radius: 0.5rem;
	border: 1px solid ${(props) => props.theme.v2.color.neutral[100]};
	background: ${(props) => props.theme.v2.color.white};

	box-shadow: 0px 16px 32px 0px ${(props) => props.theme.color.shadow.grey};
`;
